<header class="beliv-top-bar" [class.beliv-dark]="currentSkin === 'dark'">
  <!-- Left: Mobile hamburger -->
  <div class="header-left">
    <button class="btn-icon d-xl-none" (click)="toggleSidebar('menu')" aria-label="Menu">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/>
      </svg>
    </button>
  </div>

  <!-- Center: Logo -->
  <div class="header-center">
    <a [routerLink]="['/']" class="header-logo">
      <img *ngIf="currentSkin !== 'dark'"
           src="assets/images/logo/beliv-color.png" alt="Beliv" width="78" />
      <img *ngIf="currentSkin === 'dark'"
           src="assets/images/logo/beliv-blanco.png" alt="Beliv" width="78" />
    </a>
  </div>

  <!-- Right: Actions -->
  <div class="header-right">
    <!-- Buscador global (el mismo del home header): Enter lleva a /search -->
    <form class="header-search" [class.is-open]="searchOpen" (submit)="onSearchSubmit($event)" role="search">
      <lucide-icon name="search" [size]="16" class="header-search__icon"></lucide-icon>
      <input #searchInput type="text" [(ngModel)]="searchTerm" name="headerSearch" autocomplete="off"
             [placeholder]="'COMMON.ACTIONS.SEARCH' | translate"
             [attr.aria-label]="'COMMON.ACTIONS.SEARCH' | translate"
             (keydown.escape)="closeSearch()" />
      <button type="button" class="header-search__clear" *ngIf="searchTerm"
              (click)="clearSearch(searchInput)"
              [attr.aria-label]="'COMMON.BUTTONS.CLEAN' | translate">
        <lucide-icon name="x" [size]="14"></lucide-icon>
      </button>
    </form>

    <!-- En teléfono el buscador no entra en la barra: la lupa lo despliega debajo -->
    <button type="button" class="btn-icon header-search-toggle" (click)="toggleSearch(searchInput)"
            [class.is-active]="searchOpen" [attr.aria-expanded]="searchOpen"
            [attr.aria-label]="'COMMON.ACTIONS.SEARCH' | translate">
      <lucide-icon [name]="searchOpen ? 'x' : 'search'" [size]="20"></lucide-icon>
    </button>

    <!-- Company (solo si el usuario tiene acceso a más de una empresa) -->
    <div ngbDropdown class="header-action" placement="bottom-right" *ngIf="showCompanySelector">
      <button ngbDropdownToggle class="btn-icon btn-with-text company-btn" id="headerCompanyDropdown"
              [attr.aria-label]="'COMMON.LABEL.COMPANY' | translate"
              [attr.title]="selectedCompany?.name">
        <lucide-icon name="building-2" [size]="18"></lucide-icon>
        <span class="btn-label company-name d-none d-sm-inline">{{ selectedCompany?.name }}</span>
      </button>
      <div ngbDropdownMenu aria-labelledby="headerCompanyDropdown" class="dropdown-menu-right company-menu">
        <button *ngFor="let company of companies" ngbDropdownItem
                [class.active]="company.id === selectedCompany?.id"
                (click)="changeCompany(company)">
          {{ company.name }}
        </button>
      </div>
    </div>

    <!-- Language: solo la bandera, como en el home header; el nombre va en el menú -->
    <div ngbDropdown class="header-action d-none d-md-block" placement="bottom-right" *ngIf="selectedLanguage">
      <button ngbDropdownToggle class="btn-icon" id="headerLangDropdown"
              [attr.aria-label]="languageOptions[selectedLanguage]?.title"
              [attr.title]="languageOptions[selectedLanguage]?.title">
        <i class="flag-icon flag-icon-{{ languageOptions[selectedLanguage]?.flag }}"></i>
      </button>
      <div ngbDropdownMenu aria-labelledby="headerLangDropdown">
        <button *ngFor="let lang of _translateService.getLangs()" ngbDropdownItem (click)="setLanguage(lang)">
          <i class="flag-icon flag-icon-{{ languageOptions[lang]?.flag }}"></i> {{ languageOptions[lang]?.title }}
        </button>
      </div>
    </div>

    <!-- Dark mode toggle -->
    <button class="btn-icon d-none d-lg-flex" (click)="toggleDarkSkin()" aria-label="Toggle theme">
      <span [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'" class="feather"></span>
    </button>

    <!-- Switch de versión del layout (solo administradores): recarga con la otra -->
    <button type="button" class="btn-icon d-none d-lg-flex" *ngIf="layoutSwitch.canSwitch(currentUser)"
            (click)="layoutSwitch.switchLayout()"
            [attr.title]="'COMMON.ACTIONS.SWITCH_LAYOUT' | translate:{ version: layoutSwitch.targetVersion }"
            [attr.aria-label]="'COMMON.ACTIONS.SWITCH_LAYOUT' | translate:{ version: layoutSwitch.targetVersion }">
      <lucide-icon name="layout-template" [size]="20"></lucide-icon>
    </button>

    <!-- Pin / Unpin navbar on scroll -->
    <button class="btn-icon d-none d-xl-flex" (click)="onPinToggle()"
            [title]="navbarPinned ? 'Auto-ocultar al scroll' : 'Fijar navbar'">
      <svg *ngIf="navbarPinned" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
      </svg>
      <svg *ngIf="!navbarPinned" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 9.9-1"/>
      </svg>
    </button>

    <!-- Progreso de subida -->
    <ng-container *ngIf="uploadManagerService.status$ | async as upload">
      <button *ngIf="upload.active" type="button" class="btn-icon beliv-upload-fab"
              (click)="uploadManagerService.togglePanel()"
              [attr.title]="'COMMON.MESSAGES.UPLOAD_PROGRESS' | translate"
              [attr.aria-label]="'COMMON.MESSAGES.UPLOAD_PROGRESS' | translate">
        <svg class="beliv-upload-fab__ring" viewBox="0 0 36 36" aria-hidden="true">
          <circle class="beliv-upload-fab__track" cx="18" cy="18" r="16"></circle>
          <circle class="beliv-upload-fab__value" cx="18" cy="18" r="16" pathLength="100" [attr.stroke-dasharray]="upload.progress + ' 100'"></circle>
        </svg>
        <lucide-icon name="arrow-up-to-line" [size]="18" class="beliv-upload-fab__icon"></lucide-icon>
      </button>
    </ng-container>

    <!-- BIX Chat -->
    <button *ngIf="canSeeBIX" type="button" class="btn-icon d-none d-lg-flex" (click)="toggleBryant()"
       ngbPopover="{{'BELIVPEDIA.MESSAGES.VIEW_BIX' | translate}}"
       #popoverBix="ngbPopover" container="body" triggers="manual" closeDelay="60000">
      <img src="https://belivthumbs.blob.core.windows.net/prod/bot.ico" alt="Bryant" height="32" width="32" class="bix-avatar" />
    </button>

    <!-- User -->
    <div ngbDropdown class="header-action" *ngIf="currentUser">
      <!-- Solo la foto, como en el home header: el nombre se ve al abrir el menú -->
      <button ngbDropdownToggle class="btn-icon user-btn" id="headerUserDropdown"
              [attr.aria-label]="currentUser.person.name + ' ' + currentUser.person.surname"
              [attr.title]="currentUser.person.name + ' ' + currentUser.person.surname">
        <span class="avatar-wrapper">
          <img *ngIf="profilePhoto && profilePhoto.length > 0"
               class="avatar-img" [src]="profilePhoto" alt="avatar" height="36" width="36" />
          <span *ngIf="!profilePhoto || profilePhoto.length === 0" class="avatar-initials">
            {{ currentUser.person.name | slice:0:1 }}{{ currentUser.person.surname | slice:0:1 }}
          </span>
          <span class="status-online"></span>
        </span>
      </button>
      <div ngbDropdownMenu aria-labelledby="headerUserDropdown" class="dropdown-menu-right user-menu">
        <div class="dropdown-header user-menu__header">
          <span class="user-menu__name">{{ currentUser.person.name }} {{ currentUser.person.surname }}</span>
        </div>
        <div class="dropdown-divider"></div>
        <button ngbDropdownItem (click)="logout()">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="mr-50">
            <path d="M18.36 6.64a9 9 0 1 1-12.73 0"/><line x1="12" y1="2" x2="12" y2="12"/>
          </svg>
          {{ 'COMMON.BUTTONS.LOG_OUT' | translate }}
        </button>
      </div>
    </div>
  </div>
</header>
